import { render, staticRenderFns } from "./qiyecx.vue?vue&type=template&id=4ac8770f&scoped=true"
import script from "./qiyecx.vue?vue&type=script&lang=js"
export * from "./qiyecx.vue?vue&type=script&lang=js"
import style0 from "./qiyecx.vue?vue&type=style&index=0&id=4ac8770f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ac8770f",
  null
  
)

export default component.exports